import React, { useId, useState } from 'react'
import { TextField, FormControl, Popover } from '@mui/material'
import Box from '@mui/material/Box'

export const FormPopoverField = ({
    children,
    label,
    textFieldValue,
}: {
    children: React.ReactNode
    label: string
    textFieldValue: string
}) => {
    const popoverId = useId()

    const [anchorEl, setAnchorEl] = useState<Element | null>(null)

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <FormControl fullWidth>
                <TextField
                    aria-describedby={popoverId}
                    aria-readonly
                    fullWidth
                    label={label}
                    onClick={handleClick}
                    inputProps={{
                        spellCheck: 'false',
                        sx: {
                            caretColor: 'transparent',
                            cursor: 'pointer',
                        },
                    }}
                    value={textFieldValue}
                />
            </FormControl>
            <Popover
                id={popoverId}
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ padding: '20px 30px' }}>{children}</Box>
            </Popover>
        </>
    )
}
